import React from 'react'

export default function LoaderMineralValueChainEditForm() {
  return (
    <div className="flex animate-pulse flex-col gap-4">
      <div className="flex gap-4">
        <div className="flex w-full flex-col gap-1">
          <label
            className="font-bold"
            htmlFor="ID_MINERAL_IMAGE"
          >
            صورة سلسلة القيمة بالعربية<span className="text-danger-600">*</span>
          </label>
          <div className="h-96 w-full border-2 border-muted-500 bg-muted-100" />
        </div>
        <div className="flex w-full flex-col gap-1">
          <label
            className="font-bold"
            htmlFor="ID_MINERAL_IMAGE"
          >
            صورة سلسلة القيمة بالإنجليزية
          </label>
          <div className="h-96 w-full border-2 border-muted-500 bg-muted-100" />
        </div>
      </div>

      <div className="flex gap-4">
        <div className="flex w-full flex-col gap-1">
          <label
            className="line-clamp-1 font-bold"
            htmlFor="ID_MINERAL_VALUE_CHAIN_AR_SOURCE"
          >
            اسم مصدر بالعربية
          </label>
          <div className="h-11 w-full border-2 border-muted-500 bg-muted-100" />
        </div>
        <div className="flex w-full flex-col gap-1">
          <label
            className="font-bold"
            htmlFor="ID_MINERAL_VALUE_CHAIN_EN_SOURCE"
          >
            اسم مصدر بالإنجليزية
          </label>
          <div className="h-11 w-full border-2 border-muted-500 bg-muted-100" />
        </div>
      </div>
      <div className="flex w-full flex-col gap-1">
        <label
          className="line-clamp-1 font-bold"
          htmlFor="ID_MINERAL_VALUE_CHAIN_AR_SOURCE"
        >
          رابط المصدر
        </label>
        <div className="h-11 w-full border-2 border-muted-500 bg-muted-100" />
      </div>
    </div>
  )
}
